import { StateToken } from '@ngxs/store';
import { IMeetingPollState } from './meeting-poll.state';

export const MEETING_POLL_STATE_TOKEN = new StateToken<IMeetingPollState>('poll');
